import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Deliberately spare. An agent has one job here — see what they have earned and
// withdraw it — so the nav offers nothing else. Plain styling because the whole
// platform is being redesigned next.
const AgentNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut, profile } = useAuth();
  const [open, setOpen] = useState(false);

  const items = [
    { icon: '🤝', label: 'My Portal', path: '/agent' },
    { icon: '🔔', label: 'Alerts', path: '/agent/notifications' },
  ];

  const go = (path) => {
    setOpen(false);
    if (location.pathname !== path) navigate(path);
  };

  const logout = async () => {
    try { await signOut(); navigate('/login'); }
    catch (e) { navigate('/login'); }
  };

  const btn = (active) => ({
    display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
    padding: '11px 14px', marginBottom: '4px', textAlign: 'left',
    background: active ? '#111111' : 'transparent',
    color: active ? '#ffffff' : '#111111',
    border: '1px solid ' + (active ? '#111111' : 'transparent'),
    borderRadius: '3px', cursor: 'pointer', fontSize: '14px',
    fontWeight: active ? 700 : 500, fontFamily: 'inherit',
  });

  return (
    <>
      <button
        onClick={() => setOpen((p) => !p)}
        aria-label={open ? 'Close menu' : 'Open menu'}
        style={{
          position: 'fixed', top: '13px', left: '13px', zIndex: 300,
          width: '40px', height: '40px', borderRadius: '3px',
          background: '#ffffff', border: '1px solid #111111',
          color: '#111111', fontSize: '17px', cursor: 'pointer',
        }}
      >
        {open ? '✕' : '☰'}
      </button>

      {open && (
        <div onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 200 }} />
      )}

      <nav style={{
        position: 'fixed', left: 0, top: 0, bottom: 0, width: '240px',
        background: '#ffffff', borderRight: '1px solid #cccccc', zIndex: 250,
        display: 'flex', flexDirection: 'column',
        transform: open ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 0.25s ease', fontFamily: 'system-ui, sans-serif',
      }}>
        <div style={{ padding: '16px 16px 16px 62px', borderBottom: '1px solid #eeeeee' }}>
          <p style={{ margin: 0, fontWeight: 800, fontSize: '17px', color: '#111111' }}>Pharvlink</p>
          <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#666666' }}>
            Agent{profile?.full_name ? ` · ${profile.full_name}` : ''}
          </p>
        </div>

        <div style={{ padding: '12px', flex: 1 }}>
          {items.map((it) => (
            <button key={it.path} onClick={() => go(it.path)}
              style={btn(location.pathname === it.path)}>
              <span style={{ width: '20px', textAlign: 'center' }}>{it.icon}</span>
              <span>{it.label}</span>
            </button>
          ))}
        </div>

        <div style={{ padding: '12px', borderTop: '1px solid #eeeeee' }}>
          <button onClick={logout}
            style={{
              width: '100%', padding: '11px', borderRadius: '3px',
              border: '1px solid #111111', background: '#ffffff', color: '#111111',
              fontWeight: 600, fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit',
            }}>
            Sign out
          </button>
        </div>
      </nav>
    </>
  );
};

export default AgentNav;